import { render, staticRenderFns } from "./PageModule.vue?vue&type=template&id=449773ab&scoped=true&"
import script from "./PageModule.vue?vue&type=script&lang=js&"
export * from "./PageModule.vue?vue&type=script&lang=js&"
import style0 from "./PageModule.vue?vue&type=style&index=0&id=449773ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449773ab",
  null
  
)

export default component.exports